// @flow

import React, { Component } from 'react';

import { Back, BackArrow, Navbar, NavItem } from '../components/Common';
import iOSArrowBack from '../icons/ios-arrow-back.svg';
import androidArrowBack from '../icons/android-arrow-back.svg';
import { isThemeiOS } from '../themes';

type NavbarProps = {
  scrolling: boolean
};

export default class extends Component<NavbarProps, void> {
  onClickBack = (event: *): void => {
    event.preventDefault();
    window.__webview_comms__.navigate('out');
  };

  renderBack = () => (
    <Back onClick={this.onClickBack}>
      <BackArrow
        className="back"
        id="back-link"
        dangerouslySetInnerHTML={{
          __html: isThemeiOS() ?
            iOSArrowBack:
            androidArrowBack
        }}
      />
      <div className="back-text">Back</div>
    </Back>
  );

  render() {
    return (
      <Navbar className={this.props.scrolling ? 'scrolling' : ''}>
        <NavItem left>
          {this.renderBack()}
        </NavItem>
        <NavItem center>
          Settings
        </NavItem>
        <NavItem right />
      </Navbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/navbar.js